import { render, staticRenderFns } from "./Training.vue?vue&type=template&id=1a815321&scoped=true"
import script from "./Training.vue?vue&type=script&lang=js"
export * from "./Training.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a815321",
  null
  
)

export default component.exports